export class TitleRequests {
    parrotId?: string;
    imdbId?: string;
    wikibaseId?: string;
    wikipageId?: string;
    tmdbId?: string;
    tvdbId?: string;
    justwatchId?: string;
    title: string;
    link?: string;
    country?: string;
    contentType?: string;
    contentSubType?: string;
    year?: number;
    network?: string;
    note?: string;
    submitted?: boolean;
    batchUUID: string;
    batchDescription: string;

}



// WEBPACK FOOTER //
// ./src/app/catalogue/catalog-api/model/title-requests.ts